import { Education } from '../models/education.model';

export const EDUCATIONS: Education[] = [
  {
    'category': 'liberalArt',
    'projects':
      [
        {
          'title': '纽约传媒第一线',
          'imgFile': 'liberal-art/media.jpeg',
          'projectDesc':
            [
              {
                'head': '课程关键字：',
                'data': '海外传媒专业申请背景提升、传媒行业从业体验',
              },
              {
                'head': '针对人群：',
                'data': '零基础,进阶级,大师级',
              },
              {
                'head': '课程描述：',
                'data': '传媒第一线包含8个课程, 从新闻、传播、公关和影视四个行业体验美国传媒工作环境。提升学生基础实践技能, 开设视频剪辑、图像处理、传播方案制定、公关语言等基础课程。由传媒行业精英导师带领学生全程进行体验。',
              },
              {
                'head': '课程收获：',
                'data': '奖学金、项目毕业证书、传媒行业导师推荐信、海外实习机会、 Social party 海内外交流会',
              },
            ]
        },
        {
          'title': '咨询公司分析实操',
          'imgFile': 'liberal-art/consulting.jpeg',
          'projectDesc':
            [
              {
                'head': '课程关键字：',
                'data': '商科申请背景提升、咨询公司行业体验',
              },
              {
                'head': '针对人群：',
                'data': '零基础,进阶级,大师级',
              },
              {
                'head': '课程描述：',
                'data': '课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由麦肯锡(McKinsey & Company)市场部资深顾问管理导师亲自授课,了解咨询行业工作流程,与全球顶尖咨询顾问交流,接受行业精英的专业性指导,学习案例分析,实操完成一份企业咨询案例分析。',
              },
              {
                'head': '课程收获：',
                'data': '奖学金、项目毕业证书、行业导师推荐信、海外实习机会、 Social party 海内外交流会',
              }
            ]
        },
        {
          'title': '投行风险管控体验',
          'imgFile': 'liberal-art/investmentBank.jpeg',
          'projectDesc':
            [
              {
                'head': '课程关键字：',
                'data': '商科申请背景提升',
              },
              {
                'head': '针对人群：',
                'data': '零基础,进阶级,大师级',
              },
              {
                'head': '课程描述：',
                'data': '课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由摩根大通集团(JP Morgan Chase & Co)Vice President 亲自授课,体验美国投行顶级精英的日常工作,了解投行基本工作流程,实操完成企业风险管控案例分析。活动结束后,可获得课程证书及导师推荐信。',
              },
              {
                'head': '课程收获：',
                'data': '奖学金、项目毕业证书、行业导师推荐信、海外实习机会、 Social party 海内外交流会',
              }
            ]
        },
        {
          'title': '快消品牌营销专场',
          'imgFile': 'liberal-art/consumer.jpeg',
          'projectDesc':
            [
              {
                'head': '课程关键字：',
                'data': '商科申请背景提升',
              },
              {
                'head': '针对人群：',
                'data': '零基础,进阶级,大师级',
              },
              {
                'head': '课程描述：',
                'data': '本项目由美国导师全英文授课。课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由雅诗兰黛recruiter亲自授课,体验美国快消行业精英的日常工作,了解快消行业工作流程,实操完成品牌市场推广方案策划。',
              },
              {
                'head':
                  '课程收获：',
                'data':
                  '奖学金、项目毕业证书、快消行业导师推荐信、海外实习机会、 Social party 海内外交流会',
              }
            ]
        },
        {
          'title': '纽约秀场直通车',
          'imgFile': 'liberal-art/fashionShow.jpeg',
          'projectDesc':
            [
              {
                'head': '课程关键字：',
                'data': '海外艺术专业申请背景提升、时尚行业职业体验',
              },
              {
                'head': '针对人群：',
                'data': '零基础,进阶级,大师级',
              },
              {
                'head': '课程描述：',
                'data': '秀场直通车项目包含2大版块,分别由秀场导演、品牌设计师进行授课。跟随秀场导演感受秀场后台场景,跟随品牌设计师学习秀场设计经验。与设计师还有时尚品牌导师深度,扩大行业人脉关系,有机会得到设计师的工作赏识,被邀请一起工作,解决职业发展问题。得到品牌director和设计师的认可,拿到有份量的推荐信。',
              },
              {
                'head':
                  '课程收获：',
                'data':
                  '奖学金、项目毕业证书 、秀场导师或设计师推荐信、海外实习机会、 Social party 海内外交流会、线上线下听讲座',
              }
            ]
        }
      ]
  },
  {
    'category': 'science',
    'projects': [
      {
        'title': '互联网前沿体验',
        'imgFile': 'science/internet.jpeg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '海外理科专业申请背景提升, 计算机行业从业体验',
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级',
          },
          {
            'head': '课程描述：',
            'data': '跟随Amazon、Google、Facebook、Uber等行业精英了解计算机行业未来发展模式。互联网前沿体验项目包含8个课程,涵大数据、人工智能、云计算、移动开发、VR/AR、网络安全、IoT等方向,由互联网行业精英导师带领学生全程体验。',
          },
          {
            'head': '课程收获：',
            'data': '奖学金、课程成绩认定证书、互联网行业导师推荐信、海外实习机会、 Social party 海内外交流会、线上线下听讲座',
          },
        ]
      },
      {
        'title': '咨询公司分析实操',
        'imgFile': 'science/consulting.jpg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '商科申请背景提升、咨询公司行业体验',
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级',
          },
          {
            'head': '课程描述：',
            'data': '课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由麦肯锡(McKinsey & Company)市场部资深顾问管理导师亲自授课,了解咨询行业工作流程,与全球顶尖咨询顾问交流,接受行业精英的专业性指导,学习案例分析,实操完成一份企业咨询案例分析。',
          },
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书、行业导师推荐信、海外实习机会、 Social party 海内外交流会',
          },
        ]

      },
      {
        'title': '投行风险管控体验',
        'imgFile': 'science/investmentBank.jpg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '商科申请背景提升',
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级',
          },
          {
            'head': '课程描述：',
            'data': '课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由摩根大通集团(JP Morgan Chase & Co)Vice President 亲自授课,体验美国投行顶级精英的日常工作,了解投行基本工作流程,实操完成企业风险管控案例分析。活动结束后,可获得课程证书及导师推荐信。',
          },
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书、行业导师推荐信、海外实习机会、 Social party 海内外交流会',
          },
        ]

      },
      {
        'title': '保险精算与风险管理',
        'imgFile': 'science/insurance.jpeg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '商科申请背景提升',
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级',
          },
          {
            'head': '课程描述：',
            'data': '本项目由美国导师全英文授课。课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由MetLife(美国最大人寿保险公司) director亲自授课,体验美国保险行业精算师的日常工作,建立相关模型,用数据进行定价测算,风险测评全过程,实操体验美国顶级保险公司推出全新保险全过程。',
          },
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书、快消行业导师推荐信、海外实习机会、 Social party 海内外交流会',
          },
        ]

      },
    ]
  },
  {
    'category': 'engineering',
    'projects': [
      {
        'title': '探究MIT实验室',
        'imgFile': 'engineering/MITLab.jpg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '海外工科专业申请背景提升, 专业性课题研究',
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级',
          },
          {
            'head': '课程描述：',
            'data': '跟随藤校专业研究人员体验最新科技研究方向与研究成果,感受基础学科的魅力。MIT实验室探究项目包含8个课程,涵盖数学、物理、化学、生物等科学学科,并确定一个短期研究方向,由相关专业博士生1对1进行项目指导,了解美国论文写作模式,解决发表论文相关问题。'},
          {
            'head': '课程收获：',
            'data': '奖学金、课程成绩认定证书、学界导师推荐信、海外实习机会、 Social party 海内外交流会、线上线下听讲座',
          },
        ]
      },
      {
        'title': '咨询公司分析实操',
        'imgFile': 'engineering/consulting.jpg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '商科申请背景提升、咨询公司行业体验',
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级',
          },
          {
            'head': '课程描述：',
            'data': '课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由麦肯锡(McKinsey & Company)市场部资深顾问管理导师亲自授课,了解咨询行业工作流程,与全球顶尖咨询顾问交流,接受行业精英的专业性指导,学习案例分析,实操完成一份企业咨询案例分析。'},
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书、行业导师推荐信、海外实习机会、 Social party 海内外交流会',
          },
        ]

      },
      {
        'title': '投行风险管控体验',
        'imgFile': 'engineering/investmentBank.jpg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '商科申请背景提升'
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级'
          },
          {
            'head': '课程描述：',
            'data': '课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由摩根大通集团(JP Morgan Chase & Co)Vice President 亲自授课,体验美国投行顶级精英的日常工作,了解投行基本工作流程,实操完成企业风险管控案例分析。活动结束后,可获得课程证书及导师推荐信。'},
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书、行业导师推荐信、海外实习机会、 Social party 海内外交流会'},
        ]

      },
      {
        'title': '保险精算与风险管理',
        'imgFile': 'engineering/insurance.jpeg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '商科申请背景提升',
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级',
          },
          {
            'head': '课程描述：',
            'data': '本项目由美国导师全英文授课。课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由MetLife(美国最大人寿保险公司) director亲自授课,体验美国保险行业精算师的日常工作,建立相关模型,用数据进行定价测算,风险测评全过程,实操体验美国顶级保险公司推出全新保险全过程。'},
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书、快消行业导师推荐信、海外实习机会、 Social party 海内外交流会'},
        ]

      },
    ]
  },
  {
    'category': 'business',
    'projects': [
      {
        'title': '商业全方位',
        'imgFile': 'business/business.jpeg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '商科申请背景提升、商业领域职业体验'
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级'
          },
          {
            'head': '课程描述：',
            'data': '商业全方位包括投行、咨询、会计、保险、快消等行业。帮助学生在商科中找到适合自己感兴趣并且适合的方向。项目由摩根大通、麦肯锡、四大会计事务所等业界精英作为导师,带领学生进行体验式学习。'
          },
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书、行业导师推荐信、海外实习机会、 Social party 海内外交流会'
          },
        ]
      },
      {
        'title': '咨询公司分析实操',
        'imgFile': 'business/consulting.jpg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '商科申请背景提升、咨询公司行业体验'
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级'
          },
          {
            'head': '课程描述：',
            'data': '课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由麦肯锡(McKinsey & Company)市场部资深顾问管理导师亲自授课,了解咨询行业工作流程,与全球顶尖咨询顾问交流,接受行业精英的专业性指导,学习案例分析,实操完成一份企业咨询案例分析。'
          },
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书、行业导师推荐信、海外实习机会、 Social party 海内外交流会'
          },
        ]

      },
      {
        'title': '投行风险管控体验',
        'imgFile': 'business/investmentBank.jpg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '商科申请背景提升'
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级'
          },
          {
            'head': '课程描述：',
            'data': '课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由摩根大通集团(JP Morgan Chase & Co)Vice President 亲自授课,体验美国投行顶级精英的日常工作,了解投行基本工作流程,实操完成企业风险管控案例分析。活动结束后,可获得课程证书及导师推荐信。'
          },
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书、行业导师推荐信、海外实习机会、 Social party 海内外交流会'
          },
        ]

      },
      {
        'title': '快消品牌营销专场',
        'imgFile': 'business/consulting.jpg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '商科申请背景提升'
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级'
          },
          {
            'head': '课程描述：',
            'data': '本项目由美国导师全英文授课。课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由雅诗兰黛recruiter亲自授课,体验美国快消行业精英的日常工作,了解快消行业工作流程,实操完成品牌市场推广方案策划。'
          },
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书、快消行业导师推荐信、海外实习机会、 Social party 海内外交流会'
          },
        ]

      },
      {
        'title': '保险精算与风险管理',
        'imgFile': 'business/insurance.jpg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '商科申请背景提升'
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级'
          },
          {
            'head': '课程描述：',
            'data': '本项目由美国导师全英文授课。课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由MetLife(美国最大人寿保险公司) director亲自授课,体验美国保险行业精算师的日常工作,建立相关模型,用数据进行定价测算,风险测评全过程,实操体验美国顶级保险公司推出全新保险全过程。'
          },
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书、快消行业导师推荐信、海外实习机会、 Social party 海内外交流会'
          },
        ]

      },
      {
        'title': '会计四大飞跃计划',
        'imgFile': 'business/accountant.jpg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '商科申请背景提升'
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级'
          },
          {
            'head': '课程描述：',
            'data': '课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由普华永道审计导师亲自授课,体验美国会计行业精英的日常工作,了解四大会计事务所工作流程,实操企业年终账目审计项目。'
          },
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书、会计行业导师推荐信、海外实习机会、Social party 海内外交流会'
          },
        ]

      },
    ]
  },
  {
    'category': 'art',
    'projects': [
      {
        'title': '艺术设计大师行',
        'imgFile': 'art/designer.jpg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '艺术申请背景提升、作品集整理'
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级'
          },
          {
            'head': '课程描述：',
            'data': '整合高等艺术院校优质教育资源,由海外艺术高校导师直接授课。由海外教授设计课程,为学生提供前期背景评估、申请分析、作品集指导、模拟面试等完整系统服务。'
          },
          {
            'head': '课程收获：',
            'data': '奖学金、作品集 、设计行业导师推荐信、海外实习机会、 Social party 海内外交流会、线上线下听讲座'
          },
        ]
      },
      {
        'title': '咨询公司分析实操',
        'imgFile': 'art/consulting.jpg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '商科申请背景提升、咨询公司行业体验'
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级'
          },
          {
            'head': '课程描述：',
            'data': '课程包括讲座预热、案例分析、后期反馈三部分。课程时长为两月,由麦肯锡(McKinsey & Company)市场部资深顾问管理导师亲自授课,了解咨询行业工作流程,与全球顶尖咨询顾问交流,接受行业精英的专业性指导,学习案例分析,实操完成一份企业咨询案例分析。'
          },
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书、行业导师推荐信、海外实习机会、 Social party 海内外交流会'
          },
        ]

      },
      {
        'title': '纽约传媒第一线',
        'imgFile': 'art/media.jpg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '海外传媒专业申请背景提升、传媒行业从业体验'
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级'
          },
          {
            'head': '课程描述：',
            'data': '传媒第一线包含8个课程, 从新闻、传播、公关和影视四个行业体验美国传媒工作环境。提升学生基础实践技能, 开设视频剪辑、图像处理、传播方案制定、公关语言等基础课程。由传媒行业精英导师带领学生全程进行体验。'
          },
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书、传媒行业导师推荐信、海外实习机会、 Social party 海内外交流会'
          },
        ]

      },
      {
        'title': '纽约秀场直通车',
        'imgFile': 'art/fashionShow.jpg',
        'projectDesc': [
          {
            'head': '课程关键字：',
            'data': '海外艺术专业申请背景提升、时尚行业职业体验'
          },
          {
            'head': '针对人群：',
            'data': '零基础,进阶级,大师级'
          },
          {
            'head': '课程描述：',
            'data': '秀场直通车项目包含2大版块,分别由秀场导演、品牌设计师进行授课。跟随秀场导演感受秀场后台场景,跟随品牌设计师学习秀场设计经验。与设计师还有时尚品牌导师深度,扩大行业人脉关系,有机会得到设计师的工作赏识,被邀请一起工作,解决职业发展问题。得到品牌director和设计师的认可,拿到有份量的推荐信。'
          },
          {
            'head': '课程收获：',
            'data': '奖学金、项目毕业证书 、秀场导师或设计师推荐信、海外实习机会、 Social party 海内外交流会、线上线下听讲座'
          },
        ]

      },

    ]
  }
];



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/data/educations.ts